import { render } from "./StatusOrtu.vue?vue&type=template&id=13e2c9a9"
import script from "./StatusOrtu.vue?vue&type=script&lang=js"
export * from "./StatusOrtu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__